import React, { useEffect } from 'react';

const AdSense = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("Error cargando AdSense:", e);
    }
  }, []);

  return (
    <div>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-7208203722382348"
        data-ad-slot="3051527568"  // Reemplaza con tu ID de anuncio
        data-ad-format="auto"
      ></ins>
    </div>
  );
};

export default AdSense;
